<script setup lang="ts">

</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'ThinFrame',

    data(): {
        corner: {
            width: number
            height: number
        }
    } {
        return {
            corner: {
                width: 31,
                height: 28,
            }
        }
    },

    props: {
        offset: {
            type: Number,
            required: true,
        }
    },
})
</script>

<template>
    <div class="frameBox">
        <div
            :style="{
                backgroundImage: `url('/img/frame/3/top.png')`,
                top: `${-offset}px`,
                left: `${corner.width - offset}px`,
                right: `${corner.width - offset}px`,
            }"
            class="frame top horizontal"
        />

        <div
            :style="{
                backgroundImage: `url('/img/frame/3/right.png')`,
                right: `${-offset}px`,
                top: `${corner.height - offset}px`,
                bottom: `${corner.height - offset}px`,
            }"
            class="frame right vertical"
        />

        <div
            :style="{
                backgroundImage: `url('/img/frame/3/bottom.png')`,
                bottom: `${-offset}px`,
                left: `${corner.width - offset}px`,
                right: `${corner.width - offset}px`,
            }"
            class="frame bottom horizontal"
        />

        <div
            :style="{
                backgroundImage: `url('/img/frame/3/left.png')`,
                left: `${-offset}px`,
                top: `${corner.height - offset}px`,
                bottom: `${corner.height - offset}px`,
            }"
            class="frame left vertical"
        />


        <div
            :style="{
                backgroundImage: `url('/img/frame/3/top-right.png')`,
                top: `${-offset}px`,
                right: `${-offset}px`,
            }"
            class="frame corner top-right"
        />

        <div
            :style="{
                backgroundImage: `url('/img/frame/3/bottom-right.png')`,
                bottom: `${-offset}px`,
                right: `${-offset}px`,
            }"
            class="frame corner bottom-right"
        />

        <div
            :style="{
                backgroundImage: `url('/img/frame/3/bottom-left.png')`,
                bottom: `${-offset}px`,
                left: `${-offset}px`,
            }"
            class="frame corner bottom-left"
        />

        <div
            :style="{
                backgroundImage: `url('/img/frame/3/top-left.png')`,
                top: `${-offset}px`,
                left: `${-offset}px`,
            }"
            class="frame corner top-left"
        />
    </div>
</template>

<style scoped lang="scss">
.frameBox {
    position: absolute;
    pointer-events: none;
    z-index: 1000;
    width: 100%;
    height: 100%;
}

.frame {
    position: absolute;

    background-size: 100% 100%;

    &.horizontal {
        height: 8px;
    }
    &.vertical {
        width: 8px;
    }

    &.corner {
        width: v-bind('corner.width + "px"');
        height: v-bind('corner.height + "px"');
    }
}
</style>
